export var sortByTablesNumeric = function (resources) {
    if (!resources)
        return [];
    return resources.sort(function (a, b) {
        var getNumber = function (name) {
            if (!name)
                return 0;
            var match = name.match(/\d+(\.\d+)?/);
            return match ? parseFloat(match[0]) : 0;
        };
        return getNumber(a.name) - getNumber(b.name);
    });
};
export var isReservationInAvailability = function (resources, availability, reservation) {
    if (!availability || !reservation)
        return false;
    // Check if the reservation's start and end times are within any of the availabilities
    return resources === null || resources === void 0 ? void 0 : resources.every(function (res) {
        var resourceAvailabilities = availability.filter(function (avail) { return avail.entityId === res.id; });
        return resourceAvailabilities.some(function (avail) {
            var startTime = new Date(avail.startTime || 0);
            var endTime = new Date(avail.endTime || 0);
            var reservationStart = new Date(reservation.expectedStartDate || 0);
            var reservationEnd = new Date(reservation.expectedEndDate || 0);
            return reservationStart >= startTime && reservationEnd <= endTime;
        });
    });
};
// Showing green | red chips based on availability
export var isResourceAvailable = function (resource, resourcesWithAvailability, reservation) {
    var _a, _b;
    var available = (_a = resourcesWithAvailability === null || resourcesWithAvailability === void 0 ? void 0 : resourcesWithAvailability.find(function (res) { return res.id === (resource === null || resource === void 0 ? void 0 : resource.id); })) === null || _a === void 0 ? void 0 : _a.available;
    // Besides from checking availability, we need to check if user has just picked the listed table
    return available && !((_b = reservation === null || reservation === void 0 ? void 0 : reservation.resourceIds) === null || _b === void 0 ? void 0 : _b.includes(resource === null || resource === void 0 ? void 0 : resource.id));
};
